import type { Level } from './core';

export type ThemeId = 'foundry' | 'bunker' | 'crypt' | 'reactor' | 'hangar';
type Theme = {
  name: string; accent: string; light: [number, number, number]; fog: [number, number, number];
  walls: [string, string, string]; floor: string; ceiling: string;
};

export const ENVIRONMENT_TEXTURES = [
  'concrete_wall', 'metal_plate', 'rusted_panel', 'stone_wall', 'brick_wall',
  'concrete_floor', 'metal_floor', 'stone_floor',
] as const;

export const THEMES: Record<ThemeId, Theme> = {
  foundry: { name: 'Fonderie', accent: '#efb269', light: [1, .86, .7], fog: [20, 14, 11], walls: ['rusted_panel', 'metal_plate', 'metal_plate'], floor: 'metal_floor', ceiling: 'metal_plate' },
  bunker: { name: 'Bunker', accent: '#b1c9aa', light: [.86, .95, .87], fog: [12, 19, 17], walls: ['concrete_wall', 'metal_plate', 'rusted_panel'], floor: 'concrete_floor', ceiling: 'concrete_wall' },
  crypt: { name: 'Crypte', accent: '#deb58b', light: [.97, .84, .73], fog: [19, 15, 22], walls: ['stone_wall', 'brick_wall', 'stone_wall'], floor: 'stone_floor', ceiling: 'stone_wall' },
  reactor: { name: 'Réacteur', accent: '#80e1ed', light: [.76, .94, 1], fog: [8, 19, 26], walls: ['metal_plate', 'concrete_wall', 'rusted_panel'], floor: 'metal_floor', ceiling: 'metal_plate' },
  hangar: { name: 'Hangar', accent: '#efd181', light: [.97, .94, .85], fog: [17, 20, 24], walls: ['rusted_panel', 'metal_plate', 'concrete_wall'], floor: 'concrete_floor', ceiling: 'metal_plate' },
};

const MAP_THEMES: Record<string, ThemeId> = { arena: 'foundry', classic: 'bunker', maze: 'crypt', industrial: 'reactor', hangar: 'hangar' };
export function themeFor(level: Level): Theme {
  return THEMES[level.theme ?? MAP_THEMES[level.id] ?? 'bunker'];
}
